import { useEffect } from "react";
import { FEATURES_PAGE } from "@/lib/constants";
import FeaturesHero from "@/components/sections/features/FeaturesHero";
import FeatureSection from "@/components/sections/features/FeatureSection";
import MobileAppSection from "@/components/sections/features/MobileAppSection";
import FeaturesCTA from "@/components/sections/features/FeaturesCTA";

export default function FeaturesPage() {
  useEffect(() => {
    window.scrollTo(0, 0);
  }, []);

  return (
    <div data-testid="features-page">
      <FeaturesHero />
      {FEATURES_PAGE.sections.map((section, i) => (
        <FeatureSection key={section.id} section={section} index={i} />
      ))}
      <MobileAppSection />
      <FeaturesCTA />
    </div>
  );
}
